<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
    <g transform="translate(-3 -2.997)">
     <path d="M8.999,18.499v2.5h2.5l7.374-7.374l-2.5-2.5L8.999,18.499z M20.806,11.691c0.26-0.259,0.26-0.679,0.001-0.939
      c0,0-0.001-0.001-0.001-0.001l-1.56-1.56c-0.259-0.26-0.679-0.26-0.939-0.001c0,0-0.001,0.001-0.001,0.001l-1.22,1.22l2.5,2.5
      L20.806,11.691z"/>
    </g>
    </svg>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
svg {
    fill: currentColor;
}
</style>

<script>
export default {
  name: 'edit'
}
</script>
